import { tr } from '../services/i18n.js';

export const GOAL_PRESETS = [
  {
    type: 'analyses_week',
    label: '3 analyses cette semaine',
    target: 3,
    unit: 'analyses'
  },
  {
    type: 'comments_week',
    label: '5 commentaires utiles',
    target: 5,
    unit: 'commentaires'
  },
  {
    type: 'quiz_day',
    label: '1 quiz tactique par jour',
    target: 1,
    unit: 'quiz'
  }
];

export function clampNumber(value, min = 0, max = Number.MAX_SAFE_INTEGER) {
  const n = Number(value);
  if (!Number.isFinite(n)) return min;
  return Math.max(min, Math.min(max, Math.round(n)));
}

export function calculateBasePoints({ debriefs = 0, comments = 0, reactionsReceived = 0, quizEntries = 0 } = {}) {
  const d = clampNumber(debriefs);
  const c = clampNumber(comments);
  const r = Math.min(clampNumber(reactionsReceived), 50);
  const q = clampNumber(quizEntries);
  return d * 10 + c * 3 + r * 2 + q * 5;
}

export function levelFromPoints(points) {
  const safe = clampNumber(points);
  const level = Math.floor(safe / 100) + 1;
  const currentFloor = (level - 1) * 100;
  const nextFloor = level * 100;
  return {
    level,
    current: safe - currentFloor,
    next: nextFloor - currentFloor,
    label: level >= 10
      ? tr('Analyste élite', 'Elite analyst')
      : level >= 5
        ? tr('Analyste confirmé', 'Confirmed analyst')
        : tr('Analyste en herbe', 'Rising analyst')
  };
}

export function progressForGoal(goal, stats = {}) {
  const type = goal?.goal_type || goal?.type;
  const target = clampNumber(goal?.target_value || goal?.target || 1, 1);
  const current = type === 'analyses_week'
    ? clampNumber(stats.debriefs)
    : type === 'comments_week'
      ? clampNumber(stats.comments)
      : type === 'quiz_day'
        ? clampNumber(stats.quizEntries)
        : 0;
  return {
    current,
    target,
    pct: Math.min(100, Math.round((current / target) * 100)),
    done: current >= target
  };
}

export function goalPresetByType(type) {
  return GOAL_PRESETS.find((g) => g.type === type) || GOAL_PRESETS[0];
}
